/**
 * Merges base acquisition form config with element-level overrides.
 *
 * Priority (lowest → highest):
 *   base config (from API/mock, keyed by acquisition form-id)
 *     ↑ scriptCampaignId (from <script src="widget.js?tm-campaign-id=...">)
 *       ↑ elementOverrides (from data-tm-campaign-id, data-tm-display, data-tm-goal)
 *
 * @param {object} baseConfig         - Config loaded by acquisitionFormId
 * @param {string|null} scriptCampaignId - campaignId from script URL
 * @param {object} elementOverrides   - Parsed data-* attributes
 * @returns {object} Merged config
 */
export function mergeConfig(baseConfig, scriptCampaignId, elementOverrides) {
  const { campaignId, display, goal } = elementOverrides;

  const merged = {
    ...baseConfig,
    Visual: { ...baseConfig.Visual },
    Behaviour: { ...baseConfig.Behaviour }
  };

  // Campaign ID: element data-tm-campaign-id > script URL param
  merged.CampaignId = campaignId || scriptCampaignId || null;

  // AcquisitionForm ID: API config > data-tm-acquisition-form-id (the local mock config has no id)
  merged.AcquisitionFormId = baseConfig.AcquisitionFormId || elementOverrides.acquisitionFormId || null;

  // Display mode: element data-tm-display > inferred from tag (applied in index.jsx)
  if (display) {
    merged.display = display;
  }

  // Goal: element data-tm-goal > base config
  if (goal) {
    merged.Behaviour.Goal = goal;
  }

  return merged;
}
